__turbopack_context__.v({
  "active": "style-module-scss-module__nxTCUa__active",
  "agent-designation": "style-module-scss-module__nxTCUa__agent-designation",
  "agent-designation-stacked": "style-module-scss-module__nxTCUa__agent-designation-stacked",
  "agent-details": "style-module-scss-module__nxTCUa__agent-details",
  "agent-info": "style-module-scss-module__nxTCUa__agent-info",
  "agent-name": "style-module-scss-module__nxTCUa__agent-name",
  "agent-name-stacked": "style-module-scss-module__nxTCUa__agent-name-stacked",
  "agent-row": "style-module-scss-module__nxTCUa__agent-row",
  "avatar": "style-module-scss-module__nxTCUa__avatar",
  "avatar-initials": "style-module-scss-module__nxTCUa__avatar-initials",
  "avatar-initials-stacked": "style-module-scss-module__nxTCUa__avatar-initials-stacked",
  "avatar-stacked": "style-module-scss-module__nxTCUa__avatar-stacked",
  "avatar-wrap": "style-module-scss-module__nxTCUa__avatar-wrap",
  "card": "style-module-scss-module__nxTCUa__card",
  "card-in-carousel": "style-module-scss-module__nxTCUa__card-in-carousel",
  "card-stacked": "style-module-scss-module__nxTCUa__card-stacked",
  "carousel": "style-module-scss-module__nxTCUa__carousel",
  "carousel-dot": "style-module-scss-module__nxTCUa__carousel-dot",
  "carousel-dots": "style-module-scss-module__nxTCUa__carousel-dots",
  "carousel-dots-pill": "style-module-scss-module__nxTCUa__carousel-dots-pill",
  "carousel-slide": "style-module-scss-module__nxTCUa__carousel-slide",
  "carousel-track": "style-module-scss-module__nxTCUa__carousel-track",
  "component": "style-module-scss-module__nxTCUa__component",
  "contact-icon": "style-module-scss-module__nxTCUa__contact-icon",
  "contact-row": "style-module-scss-module__nxTCUa__contact-row",
  "contact-text": "style-module-scss-module__nxTCUa__contact-text",
  "copy-icon": "style-module-scss-module__nxTCUa__copy-icon",
  "courtesy-label": "style-module-scss-module__nxTCUa__courtesy-label",
});
